"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var NetworkError = /** @class */ (function (_super) {
    __extends(NetworkError, _super);
    // `errorDetails` can be an error instance, a fetch response, or a plain object. Good luck!
    function NetworkError(errorDetails) {
        var _this = _super.call(this, errorDetails.message) || this;
        _this.name = 'NetworkError';
        // Legacy redux-framework code relies on the presence of this property to check whether an error is a network error.
        _this.networkErrorMessage = errorDetails.message;
        _this.message = "We're having some trouble connecting. You might try reloading the page or checking your internet connection. " + _this.networkErrorMessage;
        // Legacy redux-framework code checks this flag to decide if it should show an error modal to the user.
        _this.shouldGlobalizeError =
            errorDetails.shouldGlobalizeError !== false &&
                !NetworkError.isFirefoxFetchError(errorDetails);
        return _this;
    }
    // Catches a very specific Firefox error that occurs when a fetch
    // request is interrupted while inflight. This error causes the global
    // error modal to appear if a user is quickly navigating to a page
    // that requires a refresh while there are inflight fetch requests.
    NetworkError.isFirefoxFetchError = function (errorDetails) {
        return Boolean(errorDetails &&
            errorDetails.name === 'TypeError' &&
            errorDetails.message ===
                'NetworkError when attempting to fetch resource.');
    };
    // Preserve backwards compatibility with legacy redux-framework code that relies on this static method existing,
    // such as the `ErrorModal` and `ErrorSummary` components.
    NetworkError.summary = function (errorInstance) {
        return errorInstance.message;
    };
    return NetworkError;
}(Error));
exports.default = NetworkError;
